import type { CardSpec } from '@itc/cards';
import { MECHANICS } from './constants.ts';
import { statusLabel } from './rules.ts';
import type { Entry, OrgInfo } from './schemas.ts';

// The Library's cards (plan 2E R8, after `imgSpec`, lines 1655 and 1665).

const WELCOME_ROLES = ['Asset Recovery Engineer', 'Cargo Hauler', 'Combat Medic', 'Capital Ship Engineer', 'Flight Deck Operations', 'Medical Officer', 'Miner', 'Salvager'];

const WELCOME_NOTE = 'Sierra keeps ITC flying: cargo hauling, resupply, logistics, transport and prepping our large ships. Every hauler, miner, salvager and donor helps.';

/** A settings list: split on commas and new lines. */
const listOf = (text: string) =>
  text
    .split(/[,\n]/)
    .map((part) => part.trim())
    .filter((part) => part !== '');

export function kbCard(entry: Pick<Entry, 'title' | 'category' | 'status' | 'patch' | 'body'>): CardSpec {
  const sub = entry.category === MECHANICS ? [statusLabel(entry.status), entry.patch].filter((part) => part !== '').join(' · ') : '';
  return { kicker: `Sierra Squadron · ${entry.category}`, title: entry.title, sub, body: entry.body };
}

export function welcomeCard(org: Pick<OrgInfo, 'welcomeContacts' | 'welcomeDropoffs' | 'welcomeNote'>): CardSpec {
  const contacts = listOf(org.welcomeContacts);
  const dropoffs = listOf(org.welcomeDropoffs);
  return {
    kicker: 'ITC Sierra Squadron',
    title: 'Welcome to Sierra Squadron',
    sub: 'Support · Supply · Logistics',
    body: org.welcomeNote === '' ? WELCOME_NOTE : org.welcomeNote,
    rows: WELCOME_ROLES.map((left) => ({ left })),
    chips: contacts.length > 0 ? { label: 'Who to contact', names: contacts } : null,
    note: `${dropoffs.length > 0 ? `Drop-off: ${dropoffs.join(', ')} · ` : ''}Ask a Sierra leader in Discord to get started.`,
  };
}
